/**
 * Cross-app channel for EventComposer UI state that other MFEs render
 * against. Today that is one signal: whether the composer's **"add another
 * space" sider** is open. Grid surfaces (schedule's meeting-rooms page) use
 * it to enter their add-space spotlight mode — fading everything outside
 * the draft's current time column and switching clicks to add-only.
 *
 * This is a STATE channel, not an event channel: the composer emits the
 * full current state on every change (and emits `open: false` when it
 * unmounts), and receivers treat the latest message as truth. A receiver
 * that mounts after the sider opened misses the earlier message and
 * defaults to closed — acceptable today because the grid page always
 * outlives the composer it opened; revisit with a state-request handshake
 * if a surface ever mounts mid-composition.
 *
 * ******* DO NOT MAKE BACKWARDS INCOMPATIBLE CHANGES *******
 * Shell and apps deploy independently. Renaming the channel constant or
 * removing a payload field can silently break listeners or emitters that
 * have not yet been redeployed.
 *
 * Safe changes:
 *   - Add a new optional field to `AddSpaceSiderState`.
 *
 * Unsafe changes:
 *   - Rename or remove the channel constant.
 *   - Remove or rename a field on `AddSpaceSiderState`.
 *   - Change a field's type or semantics.
 *
 * If an incompatible change is unavoidable, introduce a new constant
 * (`dashboard:event-composer:add-space-sider:v2`) and run both for at
 * least one release.
 */
/** The bridge channel name used as the transport. */
export var ADD_SPACE_SIDER_CHANNEL = 'dashboard:event-composer:add-space-sider';
